import React, { useEffect, useState } from "react";
import "./summaryStationWise.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LoadingOverlay from "react-loading-overlay";
import { SERVER_URL, USE_OVERLAY } from "../config/config";

const SummaryStationWise = ({ sessionObject }) => {
    const [overlay, setOverlay] = useState(false);
    const [data, setData] = useState([]);
    const [dateState, setDateState] = useState({
        date_from: new Date(),
        date_to: new Date(),
        in_stock: "2",
    });

    const fetchData = () => {
        setOverlay(true);

        const payload = {
            date_dict: {
                date_from: dateState.date_from,
                date_to: dateState.date_to,
            },
        };

        if (dateState.in_stock === "1") {
            payload.filter_fields = { in_stock: 1 };
        }

        fetch(SERVER_URL + "/report", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((data) => {
                setData(data.data || []);
                setOverlay(false);
            })
            .catch((error) => {
                console.error("Error:", error);
                setOverlay(false);
            });
    };

    useEffect(() => {
        fetchData()
    }, [dateState])

    const mergeDuplicates = (data) => {
        const mergedData = {};

        data.forEach((item) => {
            const stationFrom = (item.station_from_name || "").trim().toUpperCase();
            const stationTo = (item.station_to_name || "").trim().toUpperCase();
            if (!stationFrom || !stationTo) return; 

            const key = `${stationFrom}_${stationTo}`;

            if (!mergedData[key]) {
                mergedData[key] = { ...item, bilty_no_count: 1 };

                // Ensure all numeric fields are initialized as numbers
                mergedData[key].pkgs = Number(item.pkgs || 0);
                mergedData[key].bilty_charge = Number(item.bilty_charge || 0);
                mergedData[key].hamali = Number(item.hamali || 0);
                mergedData[key].freight = Number(item.freight || 0);
                mergedData[key].dd_charge = Number(item.dd_charge || 0);
                mergedData[key].lc_charge = Number(item.lc_charge || 0);
                mergedData[key].pf = Number(item.pf || 0);
                mergedData[key].other_amount = Number(item.other_amount || 0);
                mergedData[key].total_amount = Number(item.total_amount || 0);
            } else {
                // Accumulate values as numbers
                mergedData[key].pkgs += Number(item.pkgs || 0);
                mergedData[key].bilty_charge += Number(item.bilty_charge || 0);
                mergedData[key].hamali += Number(item.hamali || 0);
                mergedData[key].freight += Number(item.freight || 0);
                mergedData[key].dd_charge += Number(item.dd_charge || 0);
                mergedData[key].bilty_no_count++;
                mergedData[key].total_amount += Number(item.total_amount || 0);
                mergedData[key].lc_charge += Number(item.lc_charge || 0);
                mergedData[key].pf += Number(item.pf || 0);
                mergedData[key].other_amount += Number(item.other_amount || 0);
            }
        });

        return Object.values(mergedData);
    };

    const getUniqueStationNames = () => {
        const stationNames = new Set();
        data.forEach((item) => {
            stationNames.add(item.station_from_name.toUpperCase());
        });
        return Array.from(stationNames);
    };

    const calculateTotal = (data) => {
        const total = {
            pkgs: 0,
            bilty_charge: 0,
            hamali: 0,
            freight: 0,
            dd_charge: 0,
            bilty_no_count: 0,
            total_amount: 0,
            lc_charge: 0,
            pf: 0,
            other_amount: 0,
        };

        data.forEach((item) => {
            total.pkgs += Number(item.pkgs);
            total.bilty_charge += Number(item.bilty_charge);
            total.hamali += Number(item.hamali);
            total.freight += Number(item.freight);
            total.dd_charge += Number(item.dd_charge);
            total.bilty_no_count += Number(item.bilty_no_count);
            total.total_amount += Number(item.total_amount);
            total.lc_charge += Number(item.lc_charge || 0);
            total.pf += Number(item.pf || 0);
            total.other_amount += Number(item.other_amount || 0);
        });

        return total;
    };

    const mergedData = mergeDuplicates(data);

    return (
        <div className="summaryContainer">
            {USE_OVERLAY && (
                <LoadingOverlay
                    active={overlay}
                    spinner
                    text="Loading your content..."
                    styles={{
                        wrapper: {
                            overflow: true ? "hidden" : "scroll",
                        },
                    }}
                ></LoadingOverlay>
            )}
            <div className="dateHolder">
                <div>
                    From Date:{" "}
                    <DatePicker
                        dateFormat="dd-MM-yyy"
                        selected={dateState.date_from}
                        onChange={(date) =>
                            setDateState({
                                ...dateState,
                                ["date_from"]: date,
                            })
                        }
                    />
                </div>
                <div>
                    To Date:{" "}
                    <DatePicker
                        dateFormat="dd-MM-yyy"
                        selected={dateState.date_to}
                        onChange={(date) =>
                            setDateState({
                                ...dateState,
                                ["date_to"]: date,
                            })
                        }
                    />
                </div>
                <div>
                <label>Stock?</label>
                <select
                onChange={(e) => {
                    const { name, value } = e.target;
                    setDateState({
                    ...dateState,
                    [name]: value,
                    });
                }}
                value={dateState["in_stock"]}
                name="in_stock"
                >
                <option value="2" key="2">
                    All
                </option>
                <option value="1" key="1">
                    In Stock
                </option>
                </select>
                </div>
            </div>
            <div className="titleHolder">
                <span>Destination Wise Booking Summary Report</span>
            </div>
            <div className="summaryTable">
                {getUniqueStationNames().map((stationName) => (
                    <div key={stationName}>
                        <div className="branchTitleHolder">
                            <span className="branchTitle">Branch: {stationName}</span>
                        </div>
                        <table id="tabled">
                            <thead>
                                <tr>
                                    <th>Sr No.</th>
                                    <th>Station To</th>
                                    <th>Packages</th>
                                    <th>No of Bilty</th>
                                    <th>Freight</th>
                                    <th>Bilty Charge</th>
                                    <th>Hamali</th>
                                    <th>DD Charge</th>
                                    {process.env.REACT_APP_CLIENT === "guru" && (
                                        <>
                                            <th>LC Charge</th>
                                            <th>Other Amount</th>
                                            <th>PF</th>
                                        </>
                                    )}
                                    <th>Total Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {mergedData
                                    .filter((item) => item.station_from_name.toUpperCase() === stationName)
                                    .map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.station_to_name.toUpperCase()}</td>
                                            <td>{item.pkgs || 0}</td>
                                            <td>{item.bilty_no_count || 0}</td>
                                            <td>{item.freight || 0}</td>
                                            <td>{item.bilty_charge || 0}</td>
                                            <td>{item.hamali || 0}</td>
                                            <td>{item.dd_charge || 0}</td>
                                            {process.env.REACT_APP_CLIENT === "guru" && (
                                                <>
                                                    <td>{item.lc_charge || 0}</td>
                                                    <td>{item.other_amount || 0}</td>
                                                    <td>{item.pf || 0}</td>
                                                </>
                                            )}
                                            <td>{item.total_amount || 0}</td>
                                        </tr>
                                    ))}
                                <tr className="totalLabel">
                                    <td></td>
                                    <td>Total:</td>
                                    <td>{calculateTotal(mergedData.filter((item) => item.station_from_name.toUpperCase() === stationName)).pkgs}</td>
                                    <td>{calculateTotal(mergedData.filter((item) => item.station_from_name.toUpperCase() === stationName)).bilty_no_count}</td>
                                    <td>{calculateTotal(mergedData.filter((item) => item.station_from_name.toUpperCase() === stationName)).freight}</td>
                                    <td>{calculateTotal(mergedData.filter((item) => item.station_from_name.toUpperCase() === stationName)).bilty_charge}</td>
                                    <td>{calculateTotal(mergedData.filter((item) => item.station_from_name.toUpperCase() === stationName)).hamali}</td>
                                    <td>{calculateTotal(mergedData.filter((item) => item.station_from_name.toUpperCase() === stationName)).dd_charge}</td>
                                    {process.env.REACT_APP_CLIENT === "guru" && (
                                        <>
                                            <td>{calculateTotal(mergedData.filter((item) => item.station_from_name.toUpperCase() === stationName)).lc_charge}</td>
                                            <td>{calculateTotal(mergedData.filter((item) => item.station_from_name.toUpperCase() === stationName)).other_amount}</td>
                                            <td>{calculateTotal(mergedData.filter((item) => item.station_from_name.toUpperCase() === stationName)).pf}</td>
                                        </>
                                    )}
                                    <td>{calculateTotal(mergedData.filter((item) => item.station_from_name.toUpperCase() === stationName)).total_amount}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SummaryStationWise;
